import { UserPreferencesPageType } from 'src/utils/enums';
import axiosService from './axios-service';
import { NotificationPage, ProtectionPage, ReportPage, UserPreferencesDTO } from 'src/dtos/user-preferences.dto';

class UserPreferencesService {
    public getUserPreferences = async (customerId: number, serviceId: number, fetchAllServices: boolean): Promise<UserPreferencesDTO> => {
        const suffix = fetchAllServices ? 'all' : `service/${serviceId}`;
        const res = await axiosService.get(`/api/customers/userPreferences/customer/${customerId}/${suffix}`);
        return res?.data;
    };

    public updateReportPreferences = async (customerId: number, serviceId: number, pageType: UserPreferencesPageType, body: ReportPage) => {
        await axiosService.post(`/api/customers/userPreferences/customer/${customerId}/service/${serviceId}/${pageType}`, body);
    };

    public updateProtectionPreferences = async (customerId: number, serviceId: number, body: ProtectionPage) => {
        await axiosService.post(`/api/customers/userPreferences/customer/${customerId}/service/${serviceId}/protectionPage`, body);
    };

    public updateNotificationLastSeen = async (customerId: number, serviceId: number, fetchAllServices:boolean, body: NotificationPage) => {
        const suffix = fetchAllServices ? 'all' : `service/${serviceId}`;
        await axiosService.post(`/api/customers/userPreferences/customer/${customerId}/${suffix}/notifications`, body);
    };
}

const userPreferencesService = new UserPreferencesService();
export default userPreferencesService;
